import { component } from "picoapp";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import Flickity from 'flickity';
// import 'flickity-fade';
// import 'flickity/css/flickity.css';
const productDataElement = document.getElementById('product-data');
const products = productDataElement ? JSON.parse(productDataElement.textContent).products : [];


function ProductCarousel() {
  const carouselRef = useRef(null);
  let flickityInstance = null;

  const productDataElement = document.getElementById('product-data');
  const products = productDataElement ? JSON.parse(productDataElement.textContent).products : [];

  useEffect(() => {
    flickityInstance = new Flickity(carouselRef.current, {
      pageDots: false,
      cellAlign: "center",
      wrapAround: false,
      prevNextButtons: false,
      initialIndex: 0,
    });

    const defaultButton = document.querySelector(
      ".carousel-tabs button:nth-child(1)"
    );
    if (defaultButton) defaultButton.classList.add("active");

    flickityInstance.on("change", (index) => {
      const buttons = document.querySelectorAll(".carousel-tabs button");
      buttons.forEach((button, i) => {
        if (i === index) {
          button.classList.add("active");
        } else {
          button.classList.remove("active");
        }
      });
    });

    return () => {
      flickityInstance.destroy();
    };
  }, []);

  const handleTabClick = (index) => {
    flickityInstance.select(index);
  
    const buttons = document.querySelectorAll(".carousel-tabs button");
    buttons.forEach((button) => button.classList.remove("active"));
  
    const clickedButton = document.querySelector(`.carousel-tabs button[data-index='${index}']`);
    clickedButton?.classList.add("active");
  };  

  return (
    <div className="carousel-container page-view">
      <div className="carousel-title">Drinkware For <br /> Every Occasion</div>
      
      <div className="carousel-tabs">
        {products.map((product, index) => (
          <button
            key={index}
            data-index={index}
            onClick={() => handleTabClick(index)}
          >
            {product.type}
          </button>
        ))}
      </div>
      
      <div className="carousel" ref={carouselRef}>
        {products.map((product, index) => (
          <div className="carousel-cell" key={index}>
            <div className="board-container">
              <div className="carousel-cell__text">
                <h3 className="carousel-cell__title">{product.title}</h3>
                <p>{product.description || "Description unavailable"}</p>
                <div className="button-container">
                <a href={product.url} className="button">Shop Now</a>
              </div>
              </div>
              <img
              className="slider-image"
              src={product.image || 'default-image-url.jpg'}
              alt={product.type}
            />
            </div>
          </div>
        ))}
      </div>
    </div>
  );  
}

export default component((node, ctx) => {
  const element = <ProductCarousel node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
